import React from 'react';
import { pxToRem } from '@noths/polaris-client-styles';

import * as styles from './Pointer.styles';

export type PointerAlignment = 'left' | 'center' | 'right' | 'custom';

interface PointerProps {
  alignment: PointerAlignment;
  pointerCustomLeftValue?: number;
}

export const Pointer = ({ alignment, pointerCustomLeftValue }: PointerProps) => (
  <div
    css={styles.container}
    data-alignment={alignment}
    style={
      {
        '--pointer-custom-value': pointerCustomLeftValue && pxToRem(pointerCustomLeftValue),
      } as styles.PointerCSSProperties
    }
  >
    <div css={styles.pointer}></div>
  </div>
);
